<div *ngFor="let data of notificacionSuperior; let i = index">
  <auto-advice-superior [data]="data"
                        [index]="i"></auto-advice-superior>
</div>
